module.exports = __webpack_public_path__ + "static/media/email-not-found.ee5d21e8.svg";